import { Type } from "@scalar/typebox";
const DiscriminatorObjectSchemaDefinition = Type.Object({
  /** REQUIRED. The name of the property in the payload that will hold the discriminating value. This property SHOULD be required in the payload schema, as the behavior when the property is absent is undefined. */
  propertyName: Type.String(),
  /** An object to hold mappings between payload values and schema names or URI references. */
  mapping: Type.Optional(Type.Record(Type.String(), Type.String()))
});
export {
  DiscriminatorObjectSchemaDefinition
};
//# sourceMappingURL=discriminator.js.map
